import { render, staticRenderFns } from "./Achat.vue?vue&type=template&id=14248e96"
import script from "./Achat.vue?vue&type=script&lang=js"
export * from "./Achat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports